import type { ShopOption } from "@/lib/printify";
import styles from "./VariantPicker.module.css";

interface Props {
  options: ShopOption[];
  selected: number[]; // one value id per option, index-aligned with options
  onChange: (optionIndex: number, valueId: number) => void;
}

export default function VariantPicker({ options, selected, onChange }: Props) {
  return (
    <div className={styles.wrap}>
      {options.map((opt, oi) => (
        <fieldset key={opt.name} className={styles.group}>
          <legend className={styles.legend}>{opt.name}</legend>
          <div className={styles.values}>
            {opt.values.map((val) => {
              const active = selected[oi] === val.id;
              const isColor = opt.type === "color" && val.colors?.length;
              return (
                <button
                  key={val.id}
                  type="button"
                  className={`${styles.value} ${active ? styles.active : ""} ${isColor ? styles.swatch : ""}`}
                  style={isColor ? { background: val.colors![0] } : undefined}
                  aria-pressed={active}
                  aria-label={val.title}
                  title={val.title}
                  onClick={() => onChange(oi, val.id)}
                >
                  {isColor ? "" : val.title}
                </button>
              );
            })}
          </div>
        </fieldset>
      ))}
    </div>
  );
}
